import styles from './index.module.css';
import { Typography, Box } from "@material-ui/core";
import { useSelector } from 'react-redux';
import { IAppState } from '../../../../store';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { isUKOrg } from '../../../../utils/localized.syntex';

export interface IMOTReminders {
  upcoming: number
  failed: number
}

const MOTReminders = ({ data }: { data: IMOTReminders }) => {
  const history = useHistory();
  const userState = useSelector((state: IAppState) => state.authReducer.user)
  const consumerState = useSelector((state: IAppState) => state.consumerWebsiteReducer)
  const { locale, currency, address } = consumerState.consumerWebsite.organisation
  const country = address?.country || ""
  const { t } = useTranslation()

  return (
    <Box className={styles.enhancedCard}>
      <Box className={styles.cardContentEnhanced}>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography variant="h6" style={{ fontWeight: 600, color: "#1e293b", fontSize: "18px" }}>
            {isUKOrg(country) ? t("root:motReminders") : t("root:healthCheckReminders")}
          </Typography>
          <Box className={styles.metricIcon} style={{ background: "linear-gradient(135deg, #4ECDC4, #44A08D)" }}>
            📋
          </Box>
        </Box>

        <Box>
          <Box style={{ margin: "20px 0" }}>
            <Box display="flex" alignItems="center" justifyContent="center" style={{ marginBottom: "20px" }}>
              <Box
                style={{
                  padding: "12px 24px",
                  background: "linear-gradient(135deg, #4ECDC4, #44A08D)",
                  borderRadius: "20px",
                  color: "white",
                  textAlign: "center",
                }}
              >
                <Typography variant="body2" style={{ fontSize: "12px", opacity: 0.9 }}>
                  {isUKOrg(country) ? t("root:totalMotTests") : t("root:totalHealthCheckTests")}
                </Typography>
                <Typography variant="h4" style={{ fontWeight: 700, fontSize: "24px" }}>
                  {data.upcoming + data.failed}
                </Typography>
              </Box>
            </Box>

            <Box display="flex" justifyContent="space-between" style={{ gap: "12px" }}>
              <Box
                style={{
                  flex: 1,
                  padding: "20px",
                  backgroundColor: "#ecfdf5",
                  borderRadius: "16px",
                  border: "2px solid #10b981",
                  textAlign: "center",
                  position: "relative",
                }}
              >
                <Box
                  style={{
                    position: "absolute",
                    top: "-8px",
                    right: "-8px",
                    width: "24px",
                    height: "24px",
                    backgroundColor: "#10b981",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Typography style={{ color: "white", fontSize: "12px", fontWeight: "bold" }}>✓</Typography>
                </Box>
                <Typography
                  variant="body2"
                  style={{ color: "#047857", fontSize: "12px", fontWeight: 600, marginBottom: "8px" }}
                >
                  {t("root:upcoming")}
                </Typography>
                <Typography
                  variant="h3"
                  style={{
                    color: "#047857",
                    fontWeight: 700,
                    fontSize: "36px",
                    cursor: "pointer"
                  }}
                  onClick={() => history.push("/account/vehicles", {
                    showUpcomingMotVehicles: true
                  })}
                >
                  {data.upcoming}
                </Typography>
              </Box>

              <Box
                style={{
                  flex: 1,
                  padding: "20px",
                  backgroundColor: "#fef2f2",
                  borderRadius: "16px",
                  border: "2px solid #ef4444",
                  textAlign: "center",
                  position: "relative",
                }}
              >
                <Box
                  style={{
                    position: "absolute",
                    top: "-8px",
                    right: "-8px",
                    width: "24px",
                    height: "24px",
                    backgroundColor: "#ef4444",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Typography style={{ color: "white", fontSize: "12px", fontWeight: "bold" }}>!</Typography>
                </Box>
                <Typography
                  variant="body2"
                  style={{ color: "#dc2626", fontSize: "12px", fontWeight: 600, marginBottom: "8px" }}
                >
                  {t("root:failed")}
                </Typography>
                <Typography
                  variant="h3"
                  style={{
                    color: "#dc2626",
                    fontWeight: 700,
                    fontSize: "36px",
                    cursor: "pointer"
                  }}
                  onClick={() => history.push("/account/vehicles", {
                    showFailedMotVehicles: true
                  })}
                >
                  {data.failed}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default MOTReminders